/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import classNames from 'classnames';
import Select from 'react-select';
import DuplicateThemeModal from './duplicate-theme-modal';
import ManageThemesModal from './manage-themes-modal';
import { Debug, getThemes } from '../utility';
const { applyFilters, doAction, createHooks } = wp.hooks;
const merge = require('deepmerge');

//  Import core block libraries
const { __ } = wp.i18n;
const { InspectorControls } = wp.blockEditor;
const {
	PanelBody,
	PanelRow,
	ServerSideRender,
	TextControl,
	RadioControl,
	SelectControl,
	Spinner,
	Popover,
	DropdownMenu,
	MenuGroup,
	MenuItem,
	Button,
	Modal,
	TextareaControl,
} = wp.components;
const { registerBlockType } = wp.blocks;
const { Component, Fragment } = wp.element;
// Attributes that we want to preserve.
const preserve_attr = [
	'id',
	'unique_id',
	'group',
	'template',
	'gutenberg_bl',
	'faqPostId',
	'faqGroupId',
	'faq_group_toggle',
	'faq_post_title',
	'center_faq_post_title',
	'description',
	'expand_first_item',
	'accordion_mode',
	'_factory_labels',
];

export class SelectFAQThemes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			//loading: false,
			custom_themes: {},
			theme_names: [],
			isDuplicateModalOpen: false,
			isManageThemesModalOpen: false,
		};

		this.customizeTheme = this.customizeTheme.bind(this);
		this.resetTheme = this.resetTheme.bind(this);
		this.updateFaqsThemesSelect = this.updateFaqsThemesSelect.bind(this);
		this.duplicateTheme = this.duplicateTheme.bind(this);
		this.setDuplicateModalOpenStatus =
			this.setDuplicateModalOpenStatus.bind(this);
		this.setManageThemesModalOpenStatus =
			this.setManageThemesModalOpenStatus.bind(this);
		this.updateThemeList = this.updateThemeList.bind(this);
	}

	componentDidMount() {
		//console.log('componentDidMount: <SelectFAQThemes />');
		this.updateThemeList();
	}

	componentDidUpdate(prevProps, prevState) {
		//console.log('componentDidUpdate: <SelectFAQThemes />');
	}

	// Update the list of themes in the drop down from list of core themes and custom themes from REST API endpoint.
	// Called when component mounted, and from duplicate theme and manage themes modals.
	async updateThemeList(switchToTheme = null, onlyUpdateThemeLabel = false) {
		const { coreThemes, endpoint } = this.props;

		const tmp_theme_names = [];
		//console.log('coreThemes: ', coreThemes);
		//console.log('UPDATE THEME LIST: ', switchToTheme, onlyUpdateThemeLabel);

		// 1. Get list of core fixed themes and custom defined theme names from REST API endpoint

		// 1a. loop through core fixed themes object and create an array of objects to add to 'Select FAQ Theme' drop down
		const f_entries = Object.entries(coreThemes);
		//console.log('f_entries: ', f_entries);

		for (const [key, value] of f_entries) {
			const tmp = {
				value: key,
				label: value.label,
			};
			tmp_theme_names.push(tmp);
		}

		// 1b. loop through custom themes object and add to array of objects created above so 'Select FAQ Theme' drop down will contain core themes and all current custom defined themes

		const faqThemeControls = applyFilters('faq-theme-controls', false);

		let custom_themes = '{}';
		if (faqThemeControls) {
			//const custom_themes = await applyFilters('get-custom-themes', custom_themes, endpoint);
			custom_themes = await getThemes(endpoint);
		}

		//console.log('<< EP1: ', endpoint);
		//console.log('<< EP3: ', custom_themes, Object.keys(custom_themes).length);

		// only attempt to add custom themes if at least one is defined
		if (Object.keys(JSON.parse(custom_themes)).length > 0) {
			const c_entries = Object.entries(JSON.parse(custom_themes));
			for (const [key, value] of c_entries) {
				const tmp = {
					value: key,
					label: value.label,
				};
				tmp_theme_names.push(tmp);
			}
		}

		//console.log('custom_themes: ', JSON.parse(custom_themes));

		// 2. Update state (and hence, 'Select FAQ Theme' drop down value) with theme names gathered from Step 1.
		this.setState(
			{
				theme_names: tmp_theme_names,
				custom_themes: JSON.parse(custom_themes),
			},
			function () {
				const { attributes } = this.props;

				// 3. If duplicate theme modal was displayed check setting to switch to new theme immediately

				if (switchToTheme !== null) {
					const { attributes, setAttributes } = this.props;
					//let new_faq_theme = {};
					//let tmpAttr = {};

					// // copy attributes to tmp object that we want to preserve
					// const preserve_attr = ['id', 'unique_id', 'group', 'template', 'gutenberg_bl', 'faqPostId', 'faqGroupId', 'faq_group_toggle', '_factory_labels'];

					// // cycle through and add specific properties
					// preserve_attr.forEach(el => {
					// 	console.log('EL: ', el);
					// 	tmpAttr[el] = attributes[el];
					// });

					// // 3a. Get theme to switch to

					// // check in fixed themes first
					// if (coreThemes.hasOwnProperty(switchToTheme.value)) {
					// 	console.log('A');
					// 	new_faq_theme = merge.all([
					// 		coreThemes.default.faq_attributes,
					// 		coreThemes[switchToTheme.value].faq_attributes,
					// 		tmpAttr
					// 	]);
					// } else if (this.state.custom_themes.hasOwnProperty(switchToTheme.value)) {
					// 	// then check in custom defined themes

					// 	// console.log('B');
					// 	// console.log('B1: ', attributes._parent_theme, attributes );
					// 	// console.log('B2: ', coreThemes.default.faq_attributes );
					// 	// console.log('B3: ', coreThemes[attributes._parent_theme].faq_attributes );
					// 	// console.log('B4: ', this.state.custom_themes[switchToTheme.value].faq_attributes );

					// 	new_faq_theme = merge.all([
					// 		coreThemes.default.faq_attributes,
					// 		coreThemes[attributes._parent_theme].faq_attributes,
					// 		this.state.custom_themes[switchToTheme.value].faq_attributes,
					// 		tmpAttr
					// 	]);
					// } else {
					// 	// can't find theme to switch to
					// 	console.error('Can\'t switch theme. Not found.');
					// 	return; // exit without switching theme
					// }

					if (!onlyUpdateThemeLabel) {
						setAttributes({
							faq_theme_select: JSON.stringify(switchToTheme),
							faqThemeCustomizedStatus: false,
						});
						this.props.setFaqThemeEditStatus(false);
					} else {
						// only update currently selected theme label
						setAttributes({
							faq_theme_select: JSON.stringify(switchToTheme),
						});
					}

					// // when 'switching' to the new custom theme it doesn't really switch but creates a new theme and sets the edit status to false.
					// if (onlyUpdateThemeLabel) {
					// 	console.log('1. UPDATE THEME LIST: ', switchToTheme, onlyUpdateThemeLabel);

					// 	// only update drop down label
					// 	setAttributes({
					// 		faq_theme_select: JSON.stringify(switchToTheme),
					// 	});
					// } else {
					// 	console.log('2. UPDATE THEME LIST: ', switchToTheme, onlyUpdateThemeLabel);

					// 	// update drop down label and reset customised status)
					// 	setAttributes({
					// 		faq_theme_select: JSON.stringify(switchToTheme),
					// 		faqThemeCustomizedStatus: false
					// 	});
					// 	this.props.setFaqThemeEditStatus(false);
					// }

					// if (onlyUpdateThemeLabel) {
					// 	// only update drop d22own label
					// 	setAttributes({
					// 		faq_theme_select: JSON.stringify(switchToTheme),
					// 	});
					// } else {
					// 	// update all attributes (i.e. switch theme and reset customised status)
					// 	setAttributes(new_faq_theme);
					// 	this.props.setFaqThemeEditStatus(false);
					// }
				}
			}
		);
	}

	// Switch FAQ theme.
	updateFaqsThemesSelect(newVal) {
		const {
			attributes,
			faqThemeCustomizedStatus,
			setAttributes,
			setFaqThemeEditStatus,
		} = this.props;
		const { coreThemes } = this.props;
		let merge_attr = {};
		const tmpAttr = {};

		//console.log("updateFaqsThemesSelect", coreThemes.default.faq_attributes, newVal, this.state.custom_themes, attributes, tmpAttr);

		// cycle through and add specific properties
		preserve_attr.forEach((el) => {
			//console.log('EL: ', el);
			tmpAttr[el] = attributes[el];
		});
		//console.log('tmpATTR: ', tmpAttr);

		// look in core themes
		if (coreThemes.hasOwnProperty(newVal.value)) {
			//console.log("FOUND IN CORE THEMES");

			merge_attr = merge.all([
				coreThemes.default.faq_attributes,
				coreThemes[newVal.value].faq_attributes,
				tmpAttr,
			]);
		} else if (this.state.custom_themes.hasOwnProperty(newVal.value)) {
			// look in custom defined themes

			// @TODO check if the duplicates themes function stores the whole theme or just the changes?
			// If it's just the changes then we need to merge here too.
			merge_attr = merge.all([
				coreThemes.default.faq_attributes,
				coreThemes[
					this.state.custom_themes[newVal.value].faq_attributes
						._parent_theme
				].faq_attributes,
				this.state.custom_themes[newVal.value].faq_attributes,
				tmpAttr,
			]);

			//console.log(">> PARENT: ", this.state.custom_themes[newVal.value].faq_attributes._parent_theme, attributes._parent_theme);
			//console.log(
			// 	"FOUND IN CUSTOM THEMES",
			// 	coreThemes.default.faq_attributes,
			// 	this.state.custom_themes[newVal.value].faq_attributes._parent_theme,
			// 	this.state.custom_themes[newVal.value].faq_attributes,
			// 	tmpAttr
			// );
			//console.log("FOUND IN CUSTOM THEMES", this.state.custom_themes[newVal.value].faq_attributes);
		} else {
			//console.error('Theme not found.');
			return; // exit without switching theme
		}

		// @TODO Change this to proper modal so it looks better
		// if current faq theme has been customized show warning before resetting theme
		const alertText = applyFilters(
			'switch-theme-alert-text',
			'Warning! FAQ theme customizations will be lost when switching to another theme. Do you want to continue?\n\r(Note: Upgrade to Pro to save changes as a NEW custom theme.)'
		);

		if (faqThemeCustomizedStatus && !confirm(alertText)) {
			return;
		}

		// update select attribute with new theme name before calling setAttributes
		merge_attr.theme = newVal.value;
		merge_attr.faq_theme_select = JSON.stringify(newVal);

		//console.log('MERGE RESULT: ', merge_attr);

		// faqThemeCustomizedStatus will be auto set to false via default theme
		setAttributes(merge_attr);
		setFaqThemeEditStatus(false);
	}

	// Reset the FAQ theme back to default values.
	resetTheme(closeMenu) {
		const {
			attributes,
			faqThemeCustomizedStatus,
			setAttributes,
			faq_theme_select,
		} = this.props;
		const { coreThemes } = this.props;
		let merge_attr = {};
		const tmpAttr = {};
		const sel = JSON.parse(faq_theme_select).value;

		closeMenu(); // close dropdown menu

		// @TODO replace with proper modal?
		// if current faq theme has been customized show warning before resetting theme
		if (
			faqThemeCustomizedStatus &&
			!confirm(
				'Are you sure? Resetting the FAQ theme will overwrite any customizations.'
			)
		) {
			return;
		}

		// cycle through and add specific properties
		preserve_attr.forEach((el) => {
			//console.log('EL: ', el);
			tmpAttr[el] = attributes[el];
		});
		//console.log('tmpATTR: ', tmpAttr);

		// look in core themes
		if (coreThemes.hasOwnProperty(sel)) {
			//console.log("FOUND IN CORE THEMES");

			merge_attr = merge.all([
				coreThemes.default.faq_attributes,
				coreThemes[sel].faq_attributes,
				tmpAttr,
			]);
		} else if (this.state.custom_themes.hasOwnProperty(sel)) {
			// look in custom defined themes

			merge_attr = merge.all([
				coreThemes.default.faq_attributes,
				coreThemes[attributes._parent_theme].faq_attributes,
				this.state.custom_themes[sel].faq_attributes,
				tmpAttr,
			]);

			//console.log("FOUND IN CUSTOM THEMES", this.state.custom_themes[sel].faq_attributes);
		} else {
			console.error('Theme not found.');
			return; // exit without switching theme
		}

		// update select attribute with new theme name before calling setAttributes
		merge_attr.theme = sel;
		merge_attr.faq_theme_select = faq_theme_select;

		// faqThemeCustomizedStatus will be auto set to false via default theme
		setAttributes(merge_attr);
		this.props.setFaqThemeEditStatus(false);
	}

	// Open duplicate theme modal
	duplicateTheme(closeMenu) {
		closeMenu(); // close dropdown menu
		this.setState({ isDuplicateModalOpen: true });
	}

	// Open manage custom themes modal
	manageThemes(closeMenu) {
		closeMenu(); // close dropdown menu
		this.setState({ isManageThemesModalOpen: true });
	}

	// Show inspector UI controls to customize individual FAQ theme attributes
	customizeTheme(closeMenu) {
		closeMenu(); // close dropdown menu
		this.props.setFaqThemeEditStatus(true);
	}

	setDuplicateModalOpenStatus(status) {
		//console.log(['>> setDuplicateModalOpenStatus', status]);
		this.setState({ isDuplicateModalOpen: status });
	}

	setManageThemesModalOpenStatus(status) {
		//console.log(['setManageThemesModalOpenStatus', status]);
		this.setState({ isManageThemesModalOpen: status });
	}

	render() {
		const {
			coreThemes,
			endpoint,
			attributes,
			faqThemeEditStatus,
			faqThemeCustomizedStatus,
			setAttributes,
			faq_theme_select,
			className,
		} = this.props;
		const sel = JSON.parse(faq_theme_select).value;
		let faqThemeDescription = '';
		let faqThemeLabel = '';

		//console.log('DEBUG:', coreThemes, sel, this.props);
		//console.log('CT:', this.state.custom_themes);
		//console.log('LOC:', flexible_faqs_editor_data);

		// 1. Get current faq theme label and description

		// @TODO only really need to get description below as the label can be obtained from the drop down value

		// look in core themes
		if (coreThemes.hasOwnProperty(sel)) {
			faqThemeLabel = coreThemes[sel].label;
			faqThemeDescription = coreThemes[sel].description;
		} else if (this.state.custom_themes.hasOwnProperty(sel)) {
			// look in custom defined themes
			faqThemeLabel = this.state.custom_themes[sel].label;
			faqThemeDescription = this.state.custom_themes[sel].description;
		} else {
			faqThemeLabel = 'FAQ theme label not found.';
			faqThemeDescription = 'FAQ theme description.';
		}

		// Not really needed as this displays a spinning icon EVERY time an FAQ block is clicked on which doesn't look great.
		// if ( this.state.loading ) {
		//   return (
		//     <p style={{'display': 'flex', 'align-items': 'center'}} className={className} >
		//       <Spinner />
		//       { __( 'Loading post types', 'flexible-faqs' ) }
		//     </p>
		//   );
		// }

		const selectStyles = {
			menuList: (styles) => {
				return {
					...styles,
					//backgroundColor: 'red',
					paddingBottom: 0,
					paddingTop: 0,
					maxHeight: 204,
				};
			},
			menu: (styles) => {
				return {
					...styles,
					borderRadius: 0,
					//backgroundColor: 'red',
					marginBottom: '45px',
				};
			},
			singleValue: (
				styles,
				{ data, isDisabled, isFocused, isSelected }
			) => {
				//console.log('singleValue: ', styles);

				return {
					...styles,
					color: this.state.custom_themes.hasOwnProperty(data.value)
						? '#0085ba'
						: data.color,
				};
			},
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				//console.log('DATA_VALUE: ', data.value);

				return {
					...styles,
					color: isDisabled
						? '#ccc'
						: isSelected
							? 'white'
							: this.state.custom_themes.hasOwnProperty(data.value)
								? '#0085ba'
								: data.color,
					//color: this.state.custom_themes.hasOwnProperty(data.value) ? '#0085ba' : 'inherit',
					//fontStyle: this.state.custom_themes.hasOwnProperty(data.value) ? 'italic' : 'inherit'
				};
			},
			container: (styles) => ({
				...styles,
				'& div[class$="-Input"]': {
					'& input:focus': {
						boxShadow: 'none',
					},
				},
			}),
			control: (base, state) => ({
				...base,
				boxShadow: 'none',
			}),
		};

		const popOverCSS = css`
			padding: 0;

			button.components-button {
				//padding: 0;
				width: 24px;
				height: 24px;
				min-width: 0;
				border: 0;
			}

			svg {
				width: 15px;
				height: 15px;
			}

			button.components-icon-button:hover,
			button.components-icon-button:focus {
				box-shadow: none !important;
			}
		`;

		// Show 'Reset Theme', 'Customize Theme', or no menu item depending on the customized and edit statuses
		const ResetOrCustomizeMenuItem = ({
			faqThemeEditStatus,
			faqThemeCustomizedStatus,
			onClose,
		}) => {
			//console.log([faqThemeEditStatus, faqThemeCustomizedStatus, onClose]);

			if (faqThemeCustomizedStatus || faqThemeEditStatus) {
				return (
					<div className="reset-theme-btn">
						<MenuItem
							icon="image-rotate"
							onClick={() => this.resetTheme(onClose)}
						>
							Reset Theme
						</MenuItem>
					</div>
				);
			}
			return (
				<div className="reset-theme-btn">
					<MenuItem
						icon="admin-appearance"
						onClick={() => this.customizeTheme(onClose)}
					>
						Customize Theme
					</MenuItem>
				</div>
			);

			// if (faqThemeCustomizedStatus) {
			// 	return <MenuItem icon="image-rotate" onClick={() => this.resetTheme(onClose)}>Reset Theme</MenuItem>;
			// } else if (faqThemeCustomizedStatus === false && faqThemeEditStatus === false) {
			// 	return <MenuItem icon="admin-appearance" onClick={() => this.customizeTheme(onClose)}>Customize Theme</MenuItem>;
			// } else if (!faqThemeCustomizedStatus && faqThemeEditStatus) {
			// 	return null;
			// }
		};

		// Show 'Create Custom Theme' menu item if current theme has been customized.
		const CreateCustomTheme = ({
			faqThemeEditStatus,
			faqThemeCustomizedStatus,
			onClose,
		}) => {
			//console.log([faqThemeEditStatus, faqThemeCustomizedStatus, onClose]);

			if (flexible_faqs_editor_data.is_premium === '') {
				return null;
			}

			if (faqThemeCustomizedStatus) {
				return (
					<div className="create-custom-theme-btn">
						<MenuItem
							icon="format-gallery"
							onClick={() => this.duplicateTheme(onClose)}
						>
							Create New Custom Theme
						</MenuItem>
					</div>
				);
			}
			return null;
		};

		// Show 'Manage Custom Themes' menu item if we have one or more custom themes defined.
		const ManageCustomThemes = ({
			faqThemeEditStatus,
			faqThemeCustomizedStatus,
			onClose,
		}) => {
			//console.log('CUSTOM THEMES', Object.keys(this.state.custom_themes).length);

			if (flexible_faqs_editor_data.is_premium === '') {
				return null;
			}

			if (Object.keys(this.state.custom_themes).length > 0) {
				return (
					<div className="manage-custom-themes-btn">
						<MenuItem
							icon="admin-tools"
							onClick={() => this.manageThemes(onClose)}
						>
							Manage Custom Themes
						</MenuItem>
					</div>
				);
			}
			return null;
		};

		// Change this to false to disable customization of themes completely in the free version.
		const faqThemeControls = applyFilters('faq-theme-controls', true);

		//console.log("THEMES:", this.state.theme_names, typeof(this.state.theme_names));

		return (
			<div style={{ width: '100%' }}>
				<Debug off={true} props={this.props} state={this.state} />
				<div
					className="faq-theme-popout"
					style={{
						display: 'flex',
						alignItems: 'flex-end',
						justifyContent: 'space-between',
						marginBottom: '5px',
					}}
				>
					<h2 style={{ marginBottom: '3px', marginTop: '0' }}>
						Select FAQ theme{' '}
						{faqThemeCustomizedStatus && (
							<span
								title="Click the gear icon to reset theme to default settings"
								style={{
									color: '#ca4a1f',
									fontStyle: 'italic',
									fontSize: '12px',
									fontWeight: 'normal',
									marginLeft: '5px',
								}}
							>
								(customized)
							</span>
						)}
					</h2>
					{faqThemeControls && (
						<div
							style={{
								fontSize: '15px',
								cursor: 'pointer',
								marginTop: '-5px',
							}}
						>
							<DropdownMenu
								css={popOverCSS}
								icon="admin-generic"
								popoverProps={{
									className: 'faq-theme-popup-menu',
								}}
								label="FAQ theme settings"
							>
								{({ onClose }) => (
									<Fragment>
										<MenuGroup>
											<ResetOrCustomizeMenuItem
												onClose={onClose}
												faqThemeCustomizedStatus={
													faqThemeCustomizedStatus
												}
												faqThemeEditStatus={
													faqThemeEditStatus
												}
											/>
											<ManageCustomThemes
												onClose={onClose}
												faqThemeCustomizedStatus={
													faqThemeCustomizedStatus
												}
												faqThemeEditStatus={
													faqThemeEditStatus
												}
											/>
											<CreateCustomTheme
												onClose={onClose}
												faqThemeCustomizedStatus={
													faqThemeCustomizedStatus
												}
												faqThemeEditStatus={
													faqThemeEditStatus
												}
											/>
										</MenuGroup>
									</Fragment>
								)}
							</DropdownMenu>
						</div>
					)}
				</div>
				<Select
					value={JSON.parse(faq_theme_select)}
					//isMulti={multi}
					onChange={(val) => this.updateFaqsThemesSelect(val)}
					options={this.state.theme_names}
					className="react-select-container"
					classNamePrefix="react-select"
					placeholder="Select FAQ theme..."
					styles={selectStyles}
				/>
				<p
					style={{
						//fontSize: '12px',
						//lineHeight: '1.4em',
						//fontStyle: 'italic',
						marginTop: '15px',
						marginBottom: '7px',
						//color: 'rgb(117, 117, 117)',
					}}
				>
					{faqThemeDescription}
				</p>
				<DuplicateThemeModal
					coreThemes={coreThemes}
					endpoint={endpoint}
					attributes={attributes}
					faqThemeLabel={faqThemeLabel}
					faqThemeDescription={faqThemeDescription}
					updateThemeList={this.updateThemeList}
					setDuplicateModalOpenStatus={
						this.setDuplicateModalOpenStatus
					}
					isDuplicateModalOpen={this.state.isDuplicateModalOpen}
				/>
				<ManageThemesModal
					coreThemes={coreThemes}
					endpoint={endpoint}
					attributes={attributes}
					faq_theme_select={faq_theme_select}
					custom_themes={this.state.custom_themes}
					updateThemeList={this.updateThemeList}
					setManageThemesModalOpenStatus={
						this.setManageThemesModalOpenStatus
					}
					isManageThemesModalOpen={this.state.isManageThemesModalOpen}
				/>
			</div>
		);
	}
}
